<template>
  <Wrapper :header="$t('_web_profile-edit_description-header', 'Account Info')">
    <div class="row">
      <div class="col-12 mb-4">
        <TextInput
          v-model="accountVanityId"
          v-validate="{ regex: /^[\w-_]+$/ }"
          :label="$t('_web_entity-edit-vanity-id-label', 'Vanity url')"
          :placeholder="
            $t('_web_entity-edit-vanity-id-placeholder', 'Vanity url')
          "
          name="vanity_id"
          :error="errors.first('vanity_id')"
          @blur="checkVanityId"
        />
      </div>
      <AccountEditCountry class="col-6" />
      <AccountEditCity class="col-6" />
      <Description class="col-12" />
    </div>
  </Wrapper>
</template>

<script>
import Wrapper from '../../PanelWrapper';
import AccountEditCountry from './elements/Country';
import AccountEditCity from './elements/City';
import TextInput from '@/components/atoms/form/HeraFormTextInput';
import { vanityUrlEdit } from '@/views/account/content/edit/panels/mixins/vanityUrlEdit';
import Description from './Description';

export default {
  name: 'AccountEditInformationOrganization',
  components: {
    Wrapper,
    AccountEditCountry,
    AccountEditCity,
    TextInput,
    Description,
  },
  mixins: [vanityUrlEdit],
};
</script>
